import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  mapPropsToValues: () => ({
    email: "",
    otp_code: ""
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email("Digite um e-mail válido")
      .required("Este campo é obrigatório"),
    otp_code: Yup.string()
      .required("Este campo é obrigatório")
      .matches(/^\d{6}$/, "O código deve ter 6 dígitos")
  }),
  handleSubmit: values => {},
  displayName: "VerifyOTPForm",
  enableReinitialize: true
});

export default formikEnhancer;
